export default "__VITE_ASSET__bzgp_DAB__"